document.addEventListener('alpine:init', () => {
  Alpine.store('methods', {
    isMobile: document.documentElement.clientWidth <= 1024,
    cartCurrencyVariables: {
      iso_code: window.currencyVariables.iso_code, 
      name: window.currencyVariables.name,
      symbol: window.currencyVariables.symbol,
      money_format: `${window.currencyVariables.symbol}{{amount}}`
    },
    
    init() {
      window.addEventListener('resize', () => this.isMobileDevice())
    },

    getSiblings(element) {
      return [...element.parentElement.children].filter(children => children.nodeType == 1 && children != element)
    },

    isMobileDevice() {
      this.isMobile = document.documentElement.clientWidth <= 1024
    },

    formatMoney(price) {
      return window.Shopify.formatMoney(price, this.cartCurrencyVariables.money_format)
    }
  })
})